<div style="page-break-inside: avoid">
    <div class="question-rate">
  <div class="row m-t-20">
    <span class="col-7 bold-text m-b-10 m-l-20" >
      {{ detailReportQuestion.name }}
    </span>
    <span class="col-4 bold-text m-b-10" *ngIf="detailReportQuestion.averageValue">
      Avg. {{ detailReportQuestion.averageValue }}
    </span>
  </div>
  <div class="table-category" *ngIf="detailReportQuestion.participantCategories.length !== 0">
    <div class="row">
      <div class="col-12 m-l-20">
        <div class="row">
            <div class="scale-values-wrapper offset-2 col-5" style="padding-right:20px;line-height: 0.8; margin-top: 10px;">
                <div class="scale-value" *ngFor="let item of detailReportQuestion.scale.values">
                    <span class="scale-header">{{ item.value }}</span> 
                </div>
            </div>
            <div class="col-2 m-b-10">{{ 'lang.reporting.currentPeriod' | translate }}</div>
        </div>
        <app-question-scale [respondentGroup]="respondentAssesment" [scaleMaxValue] = "detailReportQuestion.scale.maxValue">
            </app-question-scale>
        <div class="col-8" style="margin:0; padding:0;">
          <hr *ngIf="otherRespondentGroup.length > 0 && respondentAssesment.length > 0" class="col-11" style="margin-left:0;"/>
        </div>
        <app-question-scale [respondentGroup]="otherRespondentGroup" [scaleMaxValue] = "detailReportQuestion.scale.maxValue">
        </app-question-scale>
      </div>
    </div>
</div>
  </div>
  <div class="question-legend" style="page-break-inside: avoid">
      <div class="row">
          <div class="scale-values-wrapper col-8 p-l-20" style="padding-right:20px;line-height: 0.8; margin-top: 10px;">
              <div class="scale-value m-b-20" *ngFor="let item of detailReportQuestion.scale.values">
                  <div class="legend-header bold-text col-12">{{ item.value }}</div><br>
                  <div class="legend-label col-12">{{ item.label }}</div>
              </div>
          </div>
        </div>
    </div>

</div>